import React, { useEffect } from 'react';
import Hero from '../components/home/Hero';
import Stats from '../components/home/Stats';
import FAQ from '../components/home/FAQ';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Solution from '../components/home/Solution';
import Social from '../components/home/Social';
import Earn from '../components/home/Earn';
import Download from '../components/home/Download';
import SponsorsCarousel from '../components/home/SponsorsCarousel';
import AnimatedSection from '../components/AnimatedSection';
import SplitMethods from '../components/home/SplitMethods';
import './Home.css';


function Home() {
  useEffect(() => {
    document.title = 'WeSplit｜The Social Layer for Group Finance';
  }, []);
  return (
    <div className="home">
      <section className="home-hero-section">
        <Navbar />
        <AnimatedSection animationType="fade-in">
          <Hero />
        </AnimatedSection>
      </section>
      <SponsorsCarousel />
      <AnimatedSection animationType="slide-up">
        <SplitMethods />
      </AnimatedSection>
      {/* <Stats /> */}
      <AnimatedSection animationType="scale-in">
        <Solution />
      </AnimatedSection>
      <AnimatedSection animationType="slide-up">
        <Social />
      </AnimatedSection>
      <AnimatedSection animationType="slide-up">
        <Earn />
      </AnimatedSection>
      <AnimatedSection animationType="scale-in">
        <Download />
      </AnimatedSection>
      <AnimatedSection animationType="slide-up">
        <FAQ />
      </AnimatedSection>
      <Footer />
    </div>
  );
}

export default Home; 